module.exports = __webpack_public_path__ + "img/placeholder_escudo.cc6152f2.svg";